import {
  Fade,
  List,
  ListItemText,
  Paper,
  Popper
} from '@mui/material';
import _ from 'lodash';
import { popperUtil } from 'modules/common';



export type CalculationRulePopperProps = popperUtil.IBasePopperProps & {
  nmf: string;
  bad: string;
  neutral: string;
  good: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: CalculationRulePopperProps) => {
  const obj = _.mapValues({
    nmf: props.nmf,
    bad: props.bad,
    neutral: props.neutral,
    good: props.good
  }, (val, key) => `${key.toUpperCase()}: ${val || '-'}`);

  const rules = _.values(obj);

  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorEl}
      onMouseLeave={() => props.handleClose()}
      transition
      sx={{
        zIndex: 1_000_000
      }}
    >
      {({ TransitionProps }) => (
        <Fade
          {...TransitionProps}
          timeout={350}
        >
          <Paper sx={{
            p: 1
          }}
          >
            <List>
              {rules.map((rule, i) => (
                <ListItemText
                  key={i}
                  primary={rule}
                />
              ))}
            </List>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};
